export interface TenantI {
  name: string;
  id: string;
  slug: string;
  status: string;
  domain: string;
  plan: string;
  logo: string;
  primaryColor: string;
  secondaryColor: string;
  subscriptionId: string;
  trialEndsAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  users: TenantUsersI[];
}

export interface TenantUsersI {
  id: string;
  tenantId: string;
  profileId: string;
  auth0Id: string;
  role: string;
  emailAddress: string;
}

/**
 * Result envelope returned by AdminRegisterService tenant mutations
 * (createTenant / updateTenant). On success `data` carries the tenant;
 * on failure the error path emits `{ success: false, error }`.
 */
export interface TenantResponse {
  success: boolean;
  data?: TenantI;
  error?: string;
}

export type SubscriptionTier = 'BASIC' | 'PRO' | 'ENTERPRISE';
export type SubscriptionStatus = 'ACTIVE' | 'TRIALING' | 'PAST_DUE' | 'CANCELED' | 'INCOMPLETE';

export interface TenantEntitlementsI {
  tenantId: string;
  tier: SubscriptionTier;
  subscriptionStatus: SubscriptionStatus | null;
  licenseActive: boolean;
  licenseExpiresAt: string | null;
  maxTestingEvents: number;
  maxBookingsPerMonth: number;
  trialActive: boolean;
  trialEndsAt: string | null;
  canAccessPlatform: boolean;
}

export interface TenantBrandingI {
  id: string;
  tenantId: string;
  primaryColor: string | null;
  secondaryColor: string | null;
  accentColor: string | null;
  logo: string | null;
  favicon: string | null;
  fontDisplay: string | null;
  fontBody: string | null;
  portalTitle: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateBrandingI {
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  logo?: string;
  favicon?: string;
  fontDisplay?: string;
  fontBody?: string;
  portalTitle?: string;
}

export interface ProvisionTenantI {
  name: string;
  slug: string;
  ownerEmail: string;
  tier: SubscriptionTier;
  domain?: string;
  stripePriceId?: string;
  trialDays?: number;
}

export interface TenantProvisioningResultI {
  tenantId: string;
  tenantSlug: string;
  ownerUserId: string;
  licenseKey: string;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  tier: SubscriptionTier;
  trialEndsAt: string | null;
}

export interface PricingPlanI {
  id: string;
  name: string;
  price: number;
  features: string[];
  buttonText: string;
  popular?: boolean;
}
